import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Loader2, MessagesSquare } from "lucide-react";
import api from "@/lib/api";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";

const fmt = (iso) => (iso ? new Date(iso).toLocaleDateString("it-IT") : "");
const STATUS = { unsubscribed: ["Disiscritto", "#EF4444"], paused: ["In pausa", "#F59E0B"], subscribed: ["Re-iscritto", "#10B981"] };

export function UnsubContactsDialog({ filter, range, onClose }) {
  const [rows, setRows] = useState(null);
  useEffect(() => {
    if (!filter) return;
    setRows(null);
    api.get("/reports/unsubscribes/contacts", { params: { start: range.start, end: range.end, reason: filter.reason || undefined, campaign_id: filter.campaign_id || undefined } })
      .then((r) => setRows(r.data || [])).catch(() => setRows([]));
  }, [filter, range.start, range.end]);
  if (!filter) return null;
  const title = filter.reason ? `Motivo «${filter.reason}»` : `Campagna «${filter.campaign_name}»`;
  return (
    <Dialog open onOpenChange={(o) => !o && onClose()}>
      <DialogContent className="bg-[#111827] border-[#1F2937] text-slate-100 max-w-2xl" data-testid="unsub-contacts-dialog">
        <DialogHeader><DialogTitle className="font-display">Clienti che hanno fatto STOP · {title}</DialogTitle></DialogHeader>
        <p className="text-xs text-slate-500 -mt-2">Periodo {fmt(range.start)} – {fmt(range.end)}{rows ? ` · ${rows.length} clienti` : ""}</p>
        {!rows ? <div className="py-6 flex justify-center"><Loader2 className="h-5 w-5 animate-spin text-slate-500" /></div> : !rows.length ? (
          <p className="text-sm text-slate-500 py-6 text-center">Nessun cliente per questo filtro.</p>
        ) : (
          <div className="max-h-[60vh] overflow-y-auto">
            <table className="w-full text-sm">
              <thead><tr className="text-left text-[11px] uppercase tracking-wide text-slate-500 border-b border-[#1F2937]">
                <th className="py-2 pr-2">Cliente</th><th className="py-2 pr-2">Data</th><th className="py-2 pr-2">Canale</th><th className="py-2 pr-2">Motivo</th><th className="py-2 pr-2">Campagna</th><th className="py-2">Stato</th>
              </tr></thead>
              <tbody data-testid="unsub-contacts-table">
                {rows.map((r, i) => {
                  const [lbl, col] = STATUS[r.status] || [r.status, "#64748B"];
                  return (
                    <tr key={`${r.phone}-${i}`} className="border-b border-[#1F2937]/60" data-testid={`unsub-contact-row-${r.phone}`}>
                      <td className="py-2 pr-2">
                        <Link to={`/chat?phone=${encodeURIComponent(r.phone)}`} className="text-slate-100 hover:text-[#10B981] inline-flex items-center gap-1" title="Apri la chat">
                          <MessagesSquare className="h-3 w-3 text-slate-500" /> {r.name || r.phone}
                        </Link>
                        {r.name && <p className="text-[11px] text-slate-500 font-mono">{r.phone}</p>}
                      </td>
                      <td className="py-2 pr-2 text-xs text-slate-400">{fmt(r.ts)}</td>
                      <td className="py-2 pr-2 text-xs text-slate-400">{r.channel === "sms" ? "SMS" : "WhatsApp"} · “{r.word}”</td>
                      <td className="py-2 pr-2 text-xs text-slate-200">{r.reason || "–"}</td>
                      <td className="py-2 pr-2 text-xs text-slate-400">{r.campaign || "–"}</td>
                      <td className="py-2 text-xs font-semibold" style={{ color: col }}>{lbl}{r.outcome === "paused" ? " (pausa)" : ""}</td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
        )}
      </DialogContent>
    </Dialog>
  );
}
